import { __rest } from '../../../../../../_virtual/_tslib.js';
import React, { useContext } from 'react';
import { NavbarHelixIcon } from './NavbarHelixIcon.js';
import { NavbarContext } from './NavbarContext.js';
import { StyledAppItem } from './ApplicationSwitcher.styles.js';
import ApplicationSwitcherAppInstanceDropdown from './ApplicationSwitcherAppInstanceDropdown.js';

var ApplicationSwitcherMenuItem = function ApplicationSwitcherMenuItem(_a) {
  var item = _a.item,
      getAppItems = _a.getAppItems,
      highlightedIndex = _a.highlightedIndex,
      getItemProps = _a.getItemProps,
      appSections = _a.appSections,
      sectionIndex = _a.sectionIndex,
      menuRef = _a.menuRef,
      setHighlightedIndex = _a.setHighlightedIndex,
      rest = __rest(_a, ["item", "getAppItems", "highlightedIndex", "getItemProps", "appSections", "sectionIndex", "menuRef", "setHighlightedIndex"]);

  var _useContext = useContext(NavbarContext),
      isDark = _useContext.isDark,
      appSwitcherLinkWrapper = _useContext.appSwitcherLinkWrapper;

  var appItem = function appItem() {
    return React.createElement(React.Fragment, null, item.icon && React.createElement("div", {
      className: 'helix-app-switcher__item-icon'
    }, React.createElement(React.Fragment, null, typeof item.icon === 'string' ? React.createElement(NavbarHelixIcon, {
      iconName: item.icon
    }) : item.icon)), React.createElement("div", {
      className: 'menu-item-content'
    }, React.createElement("span", null, React.createElement("span", {
      className: 'label'
    }, item.label), item.notActive && React.createElement("span", {
      className: 'not-active'
    }, "Try it free")), React.createElement("span", {
      className: 'description'
    }, item.description), item.appInstances && React.createElement(React.Fragment, null, React.createElement(ApplicationSwitcherAppInstanceDropdown, {
      menuRef: menuRef,
      highlightedIndex: highlightedIndex,
      setHighlightedIndex: setHighlightedIndex,
      item: item,
      usePortal: true,
      getAppItems: getAppItems
    }))));
  };

  return React.createElement(React.Fragment, null, React.createElement(StyledAppItem, Object.assign({
    isDark: isDark,
    className: "".concat(getAppItems().findIndex(function (i) {
      return i.label === item.label;
    }) === highlightedIndex ? 'highlighted' : '', " ").concat(item.divider ? 'divider' : '', " ").concat(item.selected ? 'selected-item' : '', " ").concat(item.divider || item.notActive || item.disabled ? 'disabled' : '')
  }, getItemProps({
    disabled: item.divider || item.disabled,
    item: appSections[sectionIndex],
    index: getAppItems().findIndex(function (i) {
      return i.label === item.label;
    }) > -1 ? getAppItems().findIndex(function (i) {
      return i.label === item.label;
    }) : 0
  }), rest), !item.divider && React.createElement("div", {
    className: 'menu-item-content-wrapper'
  }, item.url ? appSwitcherLinkWrapper ? appSwitcherLinkWrapper({
    item: item,
    props: {
      children: appItem()
    }
  }) : React.createElement("a", {
    href: item.url,
    target: item.target
  }, appItem()) : appItem())));
};

ApplicationSwitcherMenuItem.displayName = 'ApplicationSwitcherMenuItem';
export { ApplicationSwitcherMenuItem as default };